import { endOfMonth, lastDayOfMonth, startOfMonth, startOfYear, subDays, subMonths } from 'date-fns';

const lastMonth = subMonths(new Date(), 1);
const startOfLastMonth = startOfMonth(lastMonth);
const lastDayOfLastMonth = lastDayOfMonth(lastMonth);
const startOfYearDate = startOfYear(new Date());
const startOfMonthThreeMonthsAgo = startOfMonth(subMonths(new Date(), 3));
const startOfMonthTwelveMonthsAgo = startOfMonth(subMonths(new Date(), 12));

const datePickerFilterStaticDateRanges = [
  {
    label: 'Last 30 days',
    hasCustomRendering: false,
    range: () => ({
      startDate: subDays(new Date(), 30),
      endDate: new Date(),
      defaultAggregatorRange: 'day',
    }),
    isSelected() {
      return true;
    },
  },
  {
    label: 'Last 90 days',
    hasCustomRendering: false,
    range: () => ({
      startDate: subDays(new Date(), 90),
      endDate: new Date(),
      defaultAggregatorRange: 'week',
    }),
    isSelected() {
      return true;
    },
  },
  {
    label: 'This Month',
    hasCustomRendering: false,
    key: 'This Month',
    range: () => ({
      startDate: startOfMonth(new Date()),
      endDate: endOfMonth(new Date()),
      defaultAggregatorRange: 'day',
    }),

    isSelected() {
      return true;
    },
  },
  {
    label: 'Last Month',
    hasCustomRendering: false,
    range: () => ({
      startDate: startOfLastMonth,
      endDate: lastDayOfLastMonth,
      defaultAggregatorRange: 'day',
    }),
    isSelected: () => {
      return true;
    },
  },
  {
    label: 'Last 3 Months',
    hasCustomRendering: false,
    range: () => ({
      startDate: startOfMonthThreeMonthsAgo,
      endDate: lastDayOfLastMonth,
      defaultAggregatorRange: 'week',
    }),
    isSelected() {
      return true;
    },
  },
  {
    label: 'Year to date',
    hasCustomRendering: false,
    range: () => ({
      startDate: startOfYearDate,
      endDate: new Date(),
      defaultAggregatorRange: 'month',
    }),
    isSelected() {
      return true;
    },
  },
  {
    label: 'Last 12 Months',
    hasCustomRendering: false,
    range: () => ({
      startDate: startOfMonthTwelveMonthsAgo,
      endDate: lastDayOfLastMonth,
      defaultAggregatorRange: 'month',
    }),
    isSelected() {
      return true;
    },
  },
];

export default datePickerFilterStaticDateRanges;
